// @flow

import { getClientItem as getItemRequest, saveUserVote as saveUserVoteRequest } from 'api';
import * as actions from 'client/constants/actions';
import { apiRequestAction } from './api-request';

export type Action = { type: string, payload?: any };
export type ThunkAction = (dispatch: Dispatch, getState: () => Store) => Promise<any>;
export type Dispatch = (action: Action | ThunkAction | Promise<Action>) => Promise<void>;

export function getItem(id: string): ThunkAction {
	return async (dispatch: Dispatch) => {
		const requestAction = apiRequestAction({
			action: actions.GET_ITEM,
			request: getItemRequest,
			params: { id },
		});

		return dispatch(requestAction);
	};
}

export function saveUserChoice(data: SaveVoteReqOpts): ThunkAction {
	return async (dispatch: Dispatch) => {
		dispatch({ type: actions.SAVE_USER_CHOICE.START });

		const result = await saveUserVoteRequest(data);

		if (result.success) {
			dispatch({
				type: actions.SAVE_USER_CHOICE.SUCCESS,
				payload: { list: { ...data }, lastVotedTotalRate: result.data.usersRate },
			});
		} else {
			dispatch({ type: actions.SAVE_USER_CHOICE.FAIL, payload: result.message });
		}

		return result;
	};
}

export function setIsVoted(): ThunkAction {
	return (dispatch: Dispatch) => dispatch({ type: actions.SET_IS_VOTED, payload: { isVoted: true } });
}
